import "./index.css";

void import("./render-app");
